import Image from 'next/image';
import { useRouter } from 'next/router';
import { Box } from '@mui/material';

import { useResponsive } from '@/hooks/useResponsive';
import { CommonComponentPost } from '../CommonComponentPost';

export const ArticlePost = ({ feedContent, comments, link }) => {
  const router = useRouter();
  const isMobile = useResponsive('down', 'md');

  return (
    <CommonComponentPost
      feedContent={feedContent}
      comments={comments}
      link={link}
    >
      <>
        {feedContent?.image?.url && (
          <Box
            sx={{
              cursor: 'pointer',
              backgroundColor: feedContent?.image.dominantColor,
            }}
            position="relative"
            width="100%"
            height={isMobile ? 300 : 500}
            onClick={() => link && router.push(link.url)}
          >
            <Image
              src={feedContent?.image?.url}
              alt={feedContent?.image?.alt}
              layout="fill"
              objectFit="cover"
            />
          </Box>
        )}
        <Box sx={{ fontSize: '18px', color: '#52545F', p: '24px' }}>
          {feedContent?.tldr}
        </Box>
      </>
    </CommonComponentPost>
  );
};
